import React, { useState, useEffect } from "react";
import './TauriSidebarItem.css';
import { Link, useNavigate, useLocation } from "react-router-dom";

const TauriSidebarItem = ({ parentlist, itemlist, onSidebarItemSelected }) => {
    const [showAll, setShowAll] = useState({});
    const [activeIndex, setActiveIndex] = useState(null);
    const queryParams = new URLSearchParams(window.location.search);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        setShowAll({});
        setActiveIndex(null);

        // Automatically click the first item of the first list if available
        if (itemlist.length > 0 && itemlist[0].itemList.length > 0) {
            const firstItem = itemlist[0].itemList[0];
            const defaultPath = `${firstItem.path}/${firstItem.id}`;
            // Update the URL to the first item's path without using history
            if (location.pathname === '/') {
                navigate(defaultPath, { replace: true });
            }
        }
    }, [itemlist]);



    const renderItemList = (list, listIndex) => {
        const itemsToRender = showAll[listIndex] ? list.itemList : list.itemList.slice(0, 5);
        return (
            <ul className="nav flex-column">
                {itemsToRender.map((item, idx) => (
                    <li className="nav-item" key={`${listIndex}-${idx}`}>
                        <Link to={`${item.path}/${item.id}`}
                            className={`nav-link sidebar-item-list ${activeIndex === `${listIndex}-${idx}` ? 'active' : ''}`}
                            onClick={() => handleItemClick(`${listIndex}-${idx}`, item.name)}>
                            {item.icon && <img src={process.env.PUBLIC_URL + item.icon} alt={item.name} />}
                            {item.name}
                        </Link>
                    </li>
                ))}
                {list.itemList.length > 5 && !showAll[listIndex] && (
                    <li className="nav-item">
                        <span className="nav-link view-all" onClick={() => handleViewAll(listIndex)}>
                            View All
                        </span>
                    </li>
                )}
            </ul>
        );
    };

    const handleViewAll = (listIndex) => {
        setShowAll(prevState => ({ ...prevState, [listIndex]: true }));
    };

    const handleItemClick = (uniqueIndex, path) => {
        setActiveIndex(uniqueIndex);
        onSidebarItemSelected(parentlist, path);
    };

    return (
        <div>
            <ul className="nav flex-column">
                {itemlist.map((list, index) => (
                    <li key={index} className="nav-item">
                        <div className="header-title">{list.itemTitle}</div>
                        {renderItemList(list, index)}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default TauriSidebarItem;
